import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import {Input} from '@/components/ui/input'
import {ConfirmDialog} from '@/components/confirm-dialog'
import {tope} from '@/lib/campos-texto'

/** A#3: with real data (employees or an open evaluación) the confirm arms only after typing the exact name. */
export function DeleteBusinessDialog({
  open,
  onOpenChange,
  businessName,
  requireTypedName,
  pending,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  businessName: string
  requireTypedName: boolean
  pending: boolean
  onConfirm: () => void
}) {
  const {t} = useTranslation()
  const [typed, setTyped] = useState('')

  function handleOpenChange(next: boolean) {
    if (!next) setTyped('')
    onOpenChange(next)
  }

  if (!requireTypedName) {
    return (
      <ConfirmDialog
        open={open}
        onOpenChange={handleOpenChange}
        title={t('business.deleteDialogTitle')}
        description={t('business.deleteDialogDescription', {name: businessName})}
        confirmLabel={t('business.deleteConfirmAction')}
        cancelLabel={t('common.cancel')}
        pending={pending}
        onConfirm={onConfirm}
      />
    )
  }

  const matches = typed.trim() === businessName

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('business.deleteDialogTitle')}</AlertDialogTitle>
          <AlertDialogDescription>{t('business.deleteDialogDescription', {name: businessName})}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-2">
          <label htmlFor="delete-business-typed-name" className="text-sm text-muted-foreground">
            {t('business.deleteTypedNameLabel', {name: businessName})}
          </label>
          <Input
            maxLength={tope('NOM')}
            id="delete-business-typed-name"
            data-testid="delete-business-typed-name"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            autoComplete="off"
          />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            disabled={!matches || pending}
            data-testid="delete-business-typed-confirm"
            onClick={(e) => {
              e.preventDefault()
              onConfirm()
            }}>
            {pending ? t('common.saving') : t('business.deleteConfirmAction')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
